import styled from '@emotion/styled'
import { PictureOutlined } from '@ant-design/icons'
import { FC, useEffect, useState } from 'react'

/** รูปสำรองจากเน็ตเมื่อไม่มี URL หรือโหลดไม่สำเร็จ */
export const STOCK_NO_IMAGE_URL =
  'https://placehold.co/120x120/f0f0f0/bfbfbf/png?text=No+Image'

type StockImageThumbProps = {
  src?: string | null
  alt?: string
  className?: string
}

const StockImageThumb: FC<StockImageThumbProps> = ({
  src,
  alt = '',
  className,
}) => {
  const trimmed = src?.trim() ?? ''
  const [failed, setFailed] = useState(false)
  const [placeholderFailed, setPlaceholderFailed] = useState(false)

  useEffect(() => {
    setFailed(false)
    setPlaceholderFailed(false)
  }, [trimmed])

  const showIconOnly = !trimmed || failed

  if (showIconOnly) {
    return (
      <Wrap className={className}>
        {!placeholderFailed ? (
          <FallbackImg
            src={STOCK_NO_IMAGE_URL}
            alt={alt || 'no image'}
            onError={() => setPlaceholderFailed(true)}
          />
        ) : (
          <IconOnly>
            <PictureOutlined />
            <span>No Image</span>
          </IconOnly>
        )}
      </Wrap>
    )
  }

  return (
    <Wrap className={className}>
      <Img src={trimmed} alt={alt} onError={() => setFailed(true)} />
    </Wrap>
  )
}

export default StockImageThumb

const Wrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

const IconOnly = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #bfbfbf;
  font-size: 11px;

  .anticon {
    font-size: 22px;
  }
`
